<template>
  <app-center>
    <template v-slot:page>
      <h1 class="text-h3 primary--text">
        {{ `${$t('errors.whoops')}, ${errorCode}` }}
      </h1>
      <p>{{ $t(`errors.${errorCode}`) }}</p>
      Something is not right here. Try logging in again. If it does not help, please contact our support
      <p>
        <router-link
          v-slot="{href, route, navigate, isActive}"
          to="/login"
        >
          <NavLink :active="isActive" :href="href" @click="navigate">
            <a :href="href" @click="logout">Login page</a>
          </NavLink>
        </router-link>
      </p>
    </template>
  </app-center>
</template>

<script>
import AppCenter from '@/views/widget/AppCenter.vue';

export default {
  name: 'FourZeroOne',
  components: {
    AppCenter,
  },
  props: {
    errorCode: {
      type: Number,
      default: 401,
    },
  },
  data: () => ({}),
  methods: {
    logout() {
      this.$store.dispatch('LogOut', true);
    },
  },
};
</script>
